<template>
    <section class="panel">
        <div class="panel-heading"><h2>Course Resources<i class="clippie fa fa-info-circle" v-tooltip="'Resources are additional course materials (articles, links, etc) to further aid you.'"></i></h2></div>
        <div v-if="resources" class="panel-body">
            <div class="filter">
                <ul>
                    <li 
                    @click="toggleSelect(course.id)" 
                    v-for="course in resources"
                    :class="{'active': filters.indexOf(course.id) > -1}">
                    {{course.name}}
                </li>
            </ul>
        </div>
        <div class="resource-table" 
        v-for="course in resources"
        v-if="filters.length===0 || filters.indexOf(course.id) > -1"
        >
        <h3 class="text-center">{{course.name}}</h3>
        <table class="table table-striped">
            <thead>
                <tr>
                    <th class="resource-name">Name</th>
                    <th class="resource-description">Description</th>
                    <th class="resource-added">Added</th>
                    <th class="resource-week">Week</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="file in course.files">
                    <td class="resource-name">
                        <a v-if="file.url.includes('amazonaws')"  @click.prevent="downloadFile(file.url, file.id)">{{file.name}}</a>
                        <a v-else :href="file.url" target="_blank">{{file.name}}</a>
                    </td>
                    <td class="resource-description">{{file.description}}</td>
                    <td class="resource-added">{{file.createdAt | localDate}}</td>
                    <td class="resource-week">{{file.week}}</td>
                </tr>   
            </tbody>
        </table>

    </div>
</div>
<div v-else>
    <Loader></Loader>
</div>
</section>
</template>


<script>

import files from '../services/files';
import timeline from './widgets/Timeline.vue';
import Loader from './reusable/forum/loader.vue';


export default {
    data() {
        return {
            resources: null,
            filters: []
        }
    },
    components: {timeline,Loader},
    mounted() {
        var self = this;
        var count = 0;
        var checkLoaded;

        checkLoaded = setInterval(function() {
            if (self.$store.getters.courses.length > 0) {
                self.getResources();
                clearInterval(checkLoaded);
            } else {
                count++;
                console.log(count)
                if (count > 9) {
                    clearInterval(checkLoaded);
                }
            }
        },1000)
    },

    methods: {      
        downloadFile(file, id) {
            file = file.split('?')[0];
            this.$bus.$emit('download', file, 'resource', id);
        },
        toggleSelect(courseId) {
            let index = this.filters.indexOf(courseId);
            index === -1 ? this.filters.push(courseId) : this.filters.splice(index, 1);
        },
        getResources() {          
            var self = this;
            let myCourses = self.$store.getters.courses;
            self.$store.dispatch('toggle',{type:'loading', boolean: true});
            files.get(this, {upToWeek: parseInt(self.$store.state.currentWeek) + 1}).then(function(response) {
                var resources = [];
                var files = response.data;
                var courses = [];
                
                files.forEach(function(file) {
                    let isInCourse = myCourses.findIndex(function(c) { return c.id === file.instanceId});
                    
                    if (isInCourse > -1) {
                        let existing = courses.findIndex(function(c) { return c.id === file.courseId});

                        if (existing === -1) {
                            courses.push({
                                id: file.courseId,
                                name: file.course.name,
                                files: []
                            })
                        }
                        existing = courses.findIndex(function(c) { return c.id === file.courseId});
                        courses[existing].files.push(file);
                    }
                });
                self.resources = courses;
                self.$store.dispatch('toggle',{type:'loading', boolean: false});

            });
        }
    },

}
</script>

<style lang="scss">


.resource-table {
    background-color:#222222;
    padding:20px;
    //margin:0 15px 30px 15px;
    border-bottom:solid 1px #333;  
    tr {
        border-bottom:1px solid #666;      
    }

    td {
        height:55px;
        padding-top:15px!important;

    }

    th {
        font-weight:100;
        font-size: 15px;
        color:white;
    }

    .resource-name {
        width:25%;
    }
    .resource-description {
        width:45%;
    }
    .resource-added {
        width:20%;
    }
    .resource-week {
        width:10%;
    }

}


</style>


<style lang="scss" scoped>
table {
    table-layout: fixed;
}
.filter {
    display:flex;
    justify-content: center;
    align-items:center;
    ul {
        display:flex;
        li {
            padding:1rem;
            border:1px solid #444;
            cursor:pointer;
            &.active {
                background:#33ccff;
                color:#444;
            }
        }
    }
}
h1 {
    margin-bottom:37px;
}

h3 {
    font-weight:100;
}


.panel-body {
    padding:20px!important;
}

a {
 font-weight:400;    
 cursor:pointer; 
}



</style>


// WEBPACK FOOTER //
// Resources.vue?6460e820